<template>
  <div
    class="absolute business-tab top-120px cursor-pointer w-68px"
    :class="`${position || 'left'}-10px`"
  >
    <div v-for="tab in currentBusinessTab" :key="tab.id" :id="tab.id" @click="tabsClick(tab)">
      <el-popover
        class="flex-col-reverse flex "
        :ref="`popover-${tab.id}`"
        placement="bottom"
        popper-class="cockpit-popper"
        :append-to-body="false"
        trigger="manual"
      >
        <div class="tab-child-list">
          <p
            v-for="tabChild in tab.children"
            @click="tabsClick(tabChild)"
            :key="tabChild.id"
            :id="tabChild.id"
            class="h-28px leading-28px"
            :class="selectTabList.includes(tabChild.detail.code) ? 'tab-child-list__selected' : ''"
          >
            {{ tabChild.detail.name }}
          </p>
        </div>
        <div
          slot="reference"
          class="w-68px text-12px flex flex-col justify-items-center items-center p-5px bg-no-repeat"
        >
          <img
            class="h-50px w-50px"
            :src="selectTabList.includes(tab.detail.code) ? tab.checkedIcon : tab.uncheckIcon"
            alt=""
          />
          <div
            class="relative h-18px leading-18px w-full text-center"
            :class="
              selectTabList.includes(tab.detail.code)
                ? 'business-tab-name__checked text-[#FFF8AF]'
                : 'business-tab-name__uncheck text-[#AFFCFF]'
            "
          >
            <span class="text-14px">{{ tab.detail.name }}</span>
          </div>
        </div>
      </el-popover>
    </div>
  </div>
</template>
<script>
import { find, isEmpty, forEach } from 'lodash'

export default {
  name: 'BusinessTab',
  props: {
    position: {
      type: String,
      defalut: 'left',
    },
    tabList: {
      type: Array,
      defalut: () => {
        return []
      },
    },
    defaultTabItem: {
      type: String,
      defalut: '',
    },
    selectTab: {
      type: Array,
      defalut: () => {
        return []
      },
    },
    jumpFunction: {
      type: Object,
      defalut: () => {
        return {
          code: '',
        }
      },
    },
  },
  data() {
    return {
      changeActiveTag: false, // 是否切换tag
      lastClickTag: '', // 上一次点击的tag
      visible: false,
      currentBusinessTab: [],
      selectTabList: [],
    }
  },
  watch: {
    defaultTabItem(val) {
      if (val) {
        const currentTab = _.find(this.currentBusinessTab, (item) => {
          return item.detail.code === this.defaultTabItem
        })
        if (currentTab) {
          this.tabsClick(currentTab)
        }
      }
    },
    tabList(val) {
      // 筛选当前板块的功能
      const filterTabList = this.filterTabBar(val)
      // 组装icon
      this.setImageUrl(filterTabList)
    },
    selectTab() {
      this.selectTabList = _.clone(this.selectTab)
      _.forEach(this.currentBusinessTab, (element) => {
        if (
          element.children &&
          _.find(element.children, (el) => {
            return this.selectTab.includes(el.detail.code)
          })
        ) {
          this.selectTabList.push(element.detail.code)
        }
      })
    },
    // 点击报警消息跳转到相应的功能
    jumpFunction(val) {
      if (!isEmpty(val) && !isEmpty(val.code)) {
        const flatData = this.getFlatData(this.currentBusinessTab, [])
        const tab = find(flatData, ['detail.code', val.code])
        if (!isEmpty(tab)) {
          this.tabsClick(tab, val.openDialog)
        }
      }
    },
  },
  created() {
    window.addEventListener('openBusinessTab', this.openBusinessTab)
  },
  beforeDestroy() {
    window.removeEventListener('openBusinessTab', this.openBusinessTab)
  },
  methods: {
    openBusinessTab(e) {
      this.tabsClick(e.detail)
    },
    tabsClick(tab, openDialog) {
      if (tab && !_.isEmpty(tab.children)) {
        tab.popoverVisible = !tab.popoverVisible
        const refName = `popover-${tab.id}`
        if (tab.popoverVisible) {
          this.$refs[refName][0].doShow()
        } else {
          this.$refs[refName][0].doClose()
        }
        return
      }
      this.$emit('tabsClick', {
        id: tab.id,
        name: tab.detail.name,
        code: tab.detail.code,
        origin: 'business',
        locationType: tab.detail.functionLocationType,
        openDialog,
      })
    },
    setImageUrl(tabList) {
      this.currentBusinessTab = _.map(tabList, (element) => {
        element.popoverVisible = false
        try {
          element.checkedIcon = require(`../../assets/images/tab/${element.detail.icon}_checked.png`)
          element.uncheckIcon = require(`../../assets/images/tab/${element.detail.icon}_uncheck.png`)
        } catch (error) {
          element.checkedIcon = ''
          element.uncheckIcon = ''
        }
        return element
      })
    },
    filterTabBar(tabList) {
      // 筛选出isSelected为true的数据
      return _.filter(tabList, (element) => {
        if (element.isSelected && !_.isEmpty(element.children)) {
          element.children = this.filterTabBar(element.children)
        }
        return element.isSelected
      })
    },
    // 扁平化数据
    getFlatData(tree, flatArray = []) {
      forEach(tree, (item) => {
        flatArray.push(item)
        if (!isEmpty(item.children)) {
          this.getFlatData(item.children, flatArray)
        }
      })
      return flatArray
    },
  },
}
</script>
<style lang="scss">
.cockpit-popper.el-popover {
  position: relative !important;
  top: 0 !important;
  padding: 5px !important;
  min-width: 68px !important;
  font-size: 12px !important;
  text-align: center;
  color: #affcffcc;
  background: var(--businessTabPopoverBg);
  border: 1px solid var(--businessTabPopoverBorder) !important;

  &[x-placement^='bottom'] {
    .popper__arrow,
    .popper__arrow::after {
      background: #fff0 !important;
      border-bottom-color: #0d666f;
    }
  }
}
</style>
<style lang="scss" scoped>
.business-tab {
  overflow: hidden auto;
  height: calc(100% - 200px);

  &-name__checked {
    font-family: Ysbth;
    color: #fff;
    text-shadow: 0 0 18px #ff780072;
  }

  &-name__uncheck {
    font-family: Ysbth;
    color: #fff;
    text-shadow: 0 0 18px #82a5ff72;
  }
}

.tab-child-list {
  &__selected {
    font-family: 'Microsoft YaHei UI';
    color: #fff;
    text-shadow: 0 0 10px #00f2e5;
    font-weight: bold;
  }

  p {
    border-bottom: 1px solid #affcff26;
  }
}

::-webkit-scrollbar {
  width: 0;
  height: 0;
}
</style>
